import { colors } from "@styles/vars";
import styled from "styled-components";

export default styled.div<{ readOnly?: boolean }>`
    ${props => !props.readOnly && `
        border: 2px dashed ${colors.border};
        border-radius: 6px;
    `}
`